// src/firebase.ts
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from "firebase/app-check";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);

// Initialize App Check with reCAPTCHA Enterprise
// Debug token for local development - get token from Firebase Console → App Check → Apps → Debug token
// Only initialize App Check in production to avoid blocking local development
let appCheck;
if (process.env.NODE_ENV === "production") {
  appCheck = initializeAppCheck(app, {
    provider: new ReCaptchaEnterpriseProvider(
      process.env.REACT_APP_RECAPTCHA_SITE_KEY || "6LcjEDssAAAAAM4MzC3oXOpKBG-X_1gyVE_oUFMt"
    ),
    isTokenAutoRefreshEnabled: true,
  });
} else if (process.env.REACT_APP_APPCHECK_DEBUG_TOKEN) {
  // eslint-disable-next-line no-restricted-globals
  (self as any).FIREBASE_APPCHECK_DEBUG_TOKEN = process.env.REACT_APP_APPCHECK_DEBUG_TOKEN;
  appCheck = initializeAppCheck(app, {
    provider: new ReCaptchaEnterpriseProvider(
      process.env.REACT_APP_RECAPTCHA_SITE_KEY || "6LcjEDssAAAAAM4MzC3oXOpKBG-X_1gyVE_oUFMt"
    ),
    isTokenAutoRefreshEnabled: true,
  });
}

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);
export { appCheck };
